/**
 * @generated SignedSource<<d39098cd4aca8ffd1c5445682305611d>>
 * @relayHash 08bc9d2a69bd2c858ab39655b3facfa0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type JiraUpdateVersionReleasedStatusInput = {
  id: string;
  isReleased: boolean;
};
export type versionStatus_updateVersionReleasedMutation$variables = {
  input: JiraUpdateVersionReleasedStatusInput;
};
export type versionStatus_updateVersionReleasedMutation$data = {
  readonly jira: {
    readonly updateVersionReleasedStatus: {
      readonly success: boolean;
      readonly version: {
        readonly canAddAndRemoveIssues: boolean | null | undefined;
        readonly canEditRelatedWork: boolean | null | undefined;
        readonly status: JiraVersionStatus | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type versionStatus_updateVersionReleasedMutation = {
  response: versionStatus_updateVersionReleasedMutation$data;
  variables: versionStatus_updateVersionReleasedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "status"
},
v4 = {
  "kind": "ScalarField",
  "name": "canAddAndRemoveIssues"
},
v5 = {
  "kind": "ScalarField",
  "name": "canEditRelatedWork"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "versionStatus_updateVersionReleasedMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionReleasedStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "versionStatus_updateVersionReleasedMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionReleasedStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079",
    "metadata": {},
    "name": "versionStatus_updateVersionReleasedMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0608e97fa861a9ec4da08bc961c0e4d0";

export default node;
